import React from 'react';

import { useIntl } from 'react-intl';

import Select, { type ValueType } from '@atlaskit/select';

import { messages } from '../../common/messages';

import { getSelectedOption, type SelectOption } from './config-panel-options';
import { FieldLabel } from './config-panel-primitives';
import type { ManagedBlockGoal } from './configuration';

type GoalSelectProps = {
	goal: ManagedBlockGoal;
	isDisabled?: boolean;
	onGoalChange: (goal: ManagedBlockGoal) => void;
	options: SelectOption<ManagedBlockGoal>[];
};

export const GoalSelect = ({
	goal,
	isDisabled = false,
	onGoalChange,
	options,
}: GoalSelectProps): JSX.Element => {
	const intl = useIntl();

	return (
		<div>
			<FieldLabel htmlFor="agent-managed-extension-goal">
				{intl.formatMessage(messages.contentGoalLabel)}
			</FieldLabel>
			<Select<SelectOption<ManagedBlockGoal>>
				inputId="agent-managed-extension-goal"
				options={options}
				value={getSelectedOption(options, goal)}
				onChange={(option: ValueType<SelectOption<ManagedBlockGoal>>) => {
					if (option) {
						onGoalChange(option.value);
					}
				}}
				isDisabled={isDisabled}
				isSearchable={false}
			/>
		</div>
	);
};
